export const LOGIN_ATTEMPTS = 10;
export const LOGIN_BLOCK_MESSAGE = 'Account Locked. Please contact your System Administrator for assistance.';
